<template>
  <div class="open" style="padding: 0 1em; text-align: left">
    
    <div style="text-align: center; padding: 0.5rem 1rem; display: flex">
      <v-calendar :masks="{ title: 'YYYY MMM' }"
        is-expanded
        :disabled-dates="{ weekdays: [1, 7] }"
        :attributes="attributes" @update:from-page="pageChange"
      >
        <template v-slot:day-content="{ day, attributes }">
  <div v-if="getyearmonthday_com1(day.day)" >
    <span >{{ day.day }}</span>
    <div v-if="attributes && attributes.length && attributes[0].customData && attributes[0].customData.activities">
      <p v-for="activity in attributes[0].customData.activities"
        :key="activity.aid + '-' + day.day" 
          class="Block_shadow_3" 
         :class="attributes[0].customData.class">
        {{ activity.activeName }}
      </p>
    </div>
  </div>
  <div v-else>
    <span class="Block_shadow_2">{{ day.day }}</span>
    <div v-if="attributes && attributes.length && attributes[0].customData && attributes[0].customData.activities">
      <p v-for="activity in attributes[0].customData.activities"
         :key="activity.aid + '-' + day.day" 
         class="Block_shadow_3" 
         :class="attributes[0].customData.class">
        {{ activity.activeName }}
      </p>
    </div>
  </div>
</template>


      </v-calendar>
    </div>
   

  </div>
</template>

<script>

import * as tools from "../tool"

export default {
  name: "open",
  data() {
    return {
        cp: null, 
      attributes: [] ,
      days: [],
      masks: {
        weekdays: "WWW"
       },
      content: "",
      is_show: false,
      today1:null,
      mm:null,
      yyyy:null,
      mm1:null,//月曆月
      yyyy1:null,//月曆年
      date: null
    };
  },
   
   computed: {
        
    sysId() {
      return this.$store.getters.getSysId;
    },
     user () {
      return this.$store.getters.getUser
    },
    dates() {
      return this.days.map((day) => day.sdate);
    },
  
  },

  methods: {
    loadAttributes() {
    this.attributes = this.days.map((date) => ({
      dates: date.sActiveDate,
      customData: {
        activities: date.activities || [],
        class: "bg-red-600 text-white",
      },
    }));
    
  },
     getyearmonthday_com1 (day){
//月曆年月日


var calyyyymmdd =parseInt( String (this.yyyy1) + String(this.mm1).padStart(2, '0') + String(day).padStart(2, '0')) ;
 //目前年月日
 var yyyymmdd = parseInt(String (this.yyyy) + String(this.mm).padStart(2, '0') + String(this.today1).padStart(2, '0')) ;
var r1 = calyyyymmdd < yyyymmdd ?1:0 ;

return r1 ;

    },
    getyearmonthday_com2 (day){


//月曆年月日
var calyyyymmdd =parseInt( String (this.yyyy1) + String(this.mm1).padStart(2, '0') + String(day).padStart(2, '0')) ;
 //目前年月日
 var yyyymmdd = parseInt(String (this.yyyy) + String(this.mm).padStart(2, '0') + String(this.today1).padStart(2, '0')) ;
var r1 = calyyyymmdd >= yyyymmdd ?1:0 ;

console.log(r1);
return r1 ;

    },
     pageChange (obj) {


 this.yyyy1= obj.year;
         this.mm1= obj.month;
          

        if(this.cp!=null){
          
          
          if(this.cp.year === this.yyyy1 && this.cp.month === this.mm1 ){
                   console.log('===page not change==');
          }else{
              console.log('===Get page Data==');
              this.getDate2(this.yyyy1,this.mm1);

          }

        }else{

           console.log('===Get page Data==');
              this.getDate2(this.yyyy1,this.mm1);
        }
        console.log('===Assign Page==');
         this.cp = obj;




      },
        
   
     
  getDate2(year, month) {
  this.days = []; // 重置 days
  
  const formattedMonth = String(month).padStart(2, '0');
  const daysInMonth = new Date(year, month, 0).getDate();

  // 初始化當月的每一天為空的活動列表
  for (let day = 1; day <= daysInMonth; day++) {
    const formattedDate = `${year}-${formattedMonth}-${String(day).padStart(2, '0')}`;
    this.days.push({
      sActiveDate: formattedDate,
      activities: [], // 每天的活動設為空
    });
  }

  // 請求當月活動數據
  this.$http
    .get(`./WebApi/HighSchoolEnrolling/GetMonthActiveList/${year}/${formattedMonth}`)
    .then((response) => {
      if (response.data && Array.isArray(response.data)) {
        
        // 將活動加到對應的日期
        response.data.forEach((tDay) => {
          const dayEntry = this.days.find(d => d.sActiveDate === tDay.sActiveDate);
          
          if (dayEntry) {
            // 檢查活動是否已存在於該日期的 activities 中
            const isActivityExists = dayEntry.activities.some(activity => activity.aid === tDay.aid);
            
            if (!isActivityExists) {
              // 如果活動不存在，才加入
              dayEntry.activities.push({
                aid: tDay.aid,
                activeName: tDay.activeName,
              });
            }
          }
        });
      }
      this.loadAttributes(); // 在獲取數據後調用 loadAttributes
    })
    .catch((error) => {
      tools.showAlert(this, "danger", "對不起,網路連線失敗: " + error);
    });
},
  },
  created() {
    console.log("== OpenVCView ==");

    var dd = new Date();
this.today1= dd.getDate().toString().padStart(2, '0'); //內建getDate 取到目前年月日
this.mm =  (dd.getMonth()+1).toString().padStart(2, '0'); //January is 0!
this.yyyy = dd.getFullYear();


    
this.getDate2(this.yyyy, this.mm);
  
  },

};



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.bg-red-600 {
  --bg-opacity: 1;
  background-color: #e53e3e;
  background-color: rgba(229, 62, 62, var(--bg-opacity));
}
.text-white1 {
  color: #e2e7bf;
  font-weight: bold;
  font-size: smaller;
}
.p-text {
  color: #7c1823;
  font-size: revert;
}
</style>
